export default function SectionHeader({ kicker, title, intro, align = "left" }) {
  return (
    <div
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
      data-testid={`section-header-${(kicker || title || "").toString().toLowerCase().replace(/\s+/g, "-")}`}
    >
      {kicker && (
        <p className="text-xs uppercase tracking-[0.2em] text-brand font-semibold mb-5">
          {kicker}
        </p>
      )}
      <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight text-ink-900">
        {title}
      </h2>
      {intro && (
        <p className="mt-5 text-lg leading-relaxed text-ink-500">{intro}</p>
      )}
    </div>
  );
}
